import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import {
    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_CONSULTATION_AND_FINDINGS,
    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
    IMPLANT_SURGERY_DOCUMENTATION,
} from './const'
import initializeAlignerTreatmentPhysicianAssessment from './initialize-aligner-treatment-physician-assesment'
import initializeImplantTreatmentPhysicianAssessment from './initialize-implant-treatment-physician-assesment'
import initializeImplantConsultationAndFindings from './initialize-implant-consultation-and-findings'
import initializeImplantSurgeryDocumentation from './initialize-implant-surgery-documentation'
import * as taskDetailSelector from '../../../process/state/task-detail/selector'

export const findOrCreateAnamnesisRequest = () => ({
    type: type.FIND_OR_CREATE_ANAMNESIS_REQUEST,
    payload: {},
})

export const findOrCreateAnamnesisSuccess = anamnesis => ({
    type: type.FIND_OR_CREATE_ANAMNESIS_SUCCESS,
    payload: {
        anamnesis,
    },
})

export const findOrCreateAnamnesisError = error => ({
    type: type.FIND_OR_CREATE_ANAMNESIS_ERROR,
    payload: {
        error,
    },
})

export const initializeAnamnesis = anamnesis => {
    switch (anamnesis.templateKey) {
    case ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT:
        return initializeAlignerTreatmentPhysicianAssessment(anamnesis)
    case IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT:
        return initializeImplantTreatmentPhysicianAssessment(anamnesis)
    case IMPLANT_CONSULTATION_AND_FINDINGS:
        return initializeImplantConsultationAndFindings(anamnesis)
    case IMPLANT_SURGERY_DOCUMENTATION:
        return initializeImplantSurgeryDocumentation(anamnesis)
    default:
        return anamnesis
    }
}

export const findOrCreateAnamnesis = (customerId, templateKey) => (
    dispatch,
    getState,
) => {
    dispatch(findOrCreateAnamnesisRequest())

    const state = getState()
    const processInstanceId = taskDetailSelector.selectProcessInstanceId(state)

    get(
        '/api/anamnesis/get-or-create-anamnesis-by-customer-id?customerId=' +
            customerId +
            '&templateKey=' +
            templateKey +
            '&processInstanceId=' +
            processInstanceId,
    )
        .then(anamnesis => {
            anamnesis = initializeAnamnesis(anamnesis)
            dispatch(findOrCreateAnamnesisSuccess(anamnesis))
        })
        .catch(error => {
            dispatch(findOrCreateAnamnesisError(error))
        })
}

export const changeAnamnesis = (name, value, templateKey) => ({
    type: type.CHANGE_ANAMNESIS,
    payload: {
        name,
        value,
        templateKey,
    },
})

export const udpateAnamnesis = (anamnesis, templateKey) => ({
    type: type.UPDATE_ANAMNESIS,
    payload: {
        anamnesis,
        templateKey,
    },
})

export const saveAnamnesisRequest = () => ({
    type: type.SAVE_ANAMNESIS_REQUEST,
    payload: {},
})

export const saveAnamnesisSuccess = anamnesis => ({
    type: type.SAVE_ANAMNESIS_SUCCESS,
    payload: {
        anamnesis,
    },
})

export const saveAnamnesisError = error => ({
    type: type.SAVE_ANAMNESIS_ERROR,
    payload: {
        error,
    },
})

export const saveAnamnesis = templateKey => (dispatch, getState) => {
    const state = getState()
    const anamnesis = selector.selectAnamnesisByTemplateKey(state, templateKey)
    if (!anamnesis) {
        return
    }
    dispatch(saveAnamnesisRequest())

    post('/api/anamnesis/save-anamnesis', anamnesis)
        .then(anamnesis => {
            dispatch(saveAnamnesisSuccess(anamnesis))
        })
        .catch(error => {
            if(error.messgage) {
                return dispatch(saveAnamnesisError(error))
            }
            dispatch(saveAnamnesisError({
                messgage: 'Something went wrong. Please try again.'
            }))
        })
}

export const toggleAnamnesis = () => ({
    type: type.TOGGLE_ANAMNESIS,
})
export const toggleInfoLegend = () => ({
    type: type.TOGGLE_INFO_LEGEND,
})
export const toggleEditingTreatmentExpectation = () => ({
    type: type.TOGGLE_EDITING_TREATMENT_EXPECTATION,
})



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/action.js